import "jquery";
import * as ko from "knockout";
import { EconomyApi } from "../Apis/EconomyApi";
import { PdfApi } from "../Apis/PdfApi";
import { EReportType } from "../Models/Pdf/ReportType";
import { StatementPdfYear } from "../Models/Economy/StatementPdfYear";
import { groupBy, map, orderBy, forEach, isEmpty, isNumber, isNaN } from "lodash-es";
import { PdfInfo } from "../Models/Pdf/PdfInfo";
import { SettingsApi } from "../Apis/SettingsApi";

export class AccountStatementPdfsViewModel {
    private economyApi: EconomyApi;
    private pdfApi: PdfApi;
    private $content: JQuery;
    private expirationDate: Date;
    loading = ko.observable<boolean>(true);
    completelist = ko.observableArray<PdfInfo>()
    statementPdfYears = ko.observableArray<StatementPdfYear>();

    constructor() {
        SettingsApi.getInstance().getExpirationDate().then(res => this.expirationDate = res);
        this.economyApi = EconomyApi.getInstance();
        this.pdfApi = PdfApi.getInstance();
        this.$content = $(".pdf-content");

    }

    isNew(date: Date) {
        return date > this.expirationDate;
    }

    init(): void {
        this.pdfApi.getPdfsByType(EReportType.AccountStatementPdf).then((res) => {
            this.completelist(orderBy(res, x => (x as PdfInfo).FileName));
            
            

            ////test>
            //let pdfInfo = new PdfInfo();
            //pdfInfo.FileName = "Kontoudtog 2017-18 - 11-06-18.pdf";
            //pdfInfo.EntryNo = 12345;
            //let pdfInfos: PdfInfo[] = [pdfInfo, pdfInfo, pdfInfo];
            //statementPdfYears.push(new StatementPdfYear("2019-2018", pdfInfos));
            //statementPdfYears.push(new StatementPdfYear("2018-2017", pdfInfos));
            //statementPdfYears.push(new StatementPdfYear("2017-2016", pdfInfos));
            ////<test
            console.debug(`complete list:${res}`);
            this.delay(150).then(() => {
                this.loading(false);
                this.$content.removeClass("d-none");
                this.$content.css("display", "inline");
            });
        });
    }


    /*
     * Collection used for the graphic table representations.
     */
    private groupedByYear: KnockoutComputed<StatementPdfYear[]> = ko.computed(() => {
        let list = new Array<StatementPdfYear>();
        var tmp = this.completelist();
        var groupedList = groupBy(
            orderBy(this.completelist(), (c: PdfInfo) => {
                return this.getYear(c.PostingYear);
            })
            , (item) => {
                return this.getYear(item.PostingYear);
            }
        );
        forEach(groupedList, e => {
            const year = this.getYear(e[0].PostingYear);
            list.push(new StatementPdfYear(year, e[0].PostingYear, e));
        });

        return orderBy(list, c => c.Year, 'desc');
    });

    private getYear(source: string): number {

        let year = '';
        if (source.indexOf('-') > -1)
            year = source.split('-')[0];

        else if (source.indexOf('_') > - 1)
            year = source.split('_')[0];

        else if (source.indexOf('.') > -1)
            year = source.split('.')[0];

        if (year.length == 4 && parseInt(year) > 0)
            return Number(year);

        return 0;
    }

    private delay(ms: number) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}